module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.div_class
  }, [(_vm.isEnable) ? _c('router-link', {
    attrs: {
      "to": _vm.linkTo
    }
  }, [_c('button', {
    class: 'btn btn-lg btn-primary menu-btn menu-btn-enabled ' + _vm.btn_class,
    attrs: {
      "type": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.btnText)
    }
  })]) : _c('button', {
    staticClass: "btn btn-lg btn-default menu-btn menu-btn-disabled",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.btnText)
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba0810c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-btn.vue
// module id = 1056
// module chunks = 0